
import { IonCol, IonGrid, IonNote,IonRow, IonText, IonImg} from '@ionic/react';
import './EbioroLoadingLogo.css'
import { PropsWithChildren } from 'react';

interface myProps extends PropsWithChildren {
  icon_color?:string;
  mainText:string;
  mainTextColor:string;
  subText?:string;
  subTextColor?:string;
}

const EbioroLoadingLogo: React.FC<myProps> = ({
  icon_color,
  mainText,
  mainTextColor,
  subText,
  subTextColor
}) => {

  return (
   
    <div className='ion-text-center'>
      <IonGrid >
        <IonRow>
          <IonCol >
            <div style={{ width: 100, height: 100, }} >
              {
                icon_color==='orange'?
                
                (<IonImg src="/assets/img/ebioro-symbol-orange.svg" className="loading-logo-animated" />)
                
                :icon_color==='black'?
                
                (<IonImg src="/assets/img/ebioro-symbol-black.svg" className="loading-logo-animated" />)
                
                :icon_color==='white'?
                
                (<IonImg src="/assets/img/ebioro-symbol-white.svg" className="loading-logo-animated" />)
                
                :

                (
                  <IonImg src="/assets/img/ebioro-symbol-darkblue.svg" className="loading-logo-animated" />
                )
              }
              
            </div>
          </IonCol>
        </IonRow>
      </IonGrid>



      <div className='loading-content'>
        <IonText style={{color:`${mainTextColor}`}}  >
          <h4 >{mainText} </h4>
        </IonText>
        <IonText >
          <IonNote style={{color:`${subTextColor}`}}>{subText}</IonNote>
        </IonText>
      </div>


    </div>
   
  )
}

export default EbioroLoadingLogo
